<template>
  <div>
    <router-view/>
  </div>
</template>

<script>
export default {
  name: "Factor",
  data() {
    return {};
  }
};
</script>

<style scoped lang="scss">
</style>

